import {
	GetReferralsModel,
	GetReferralsParams,
	ReferralStatusEnum,
} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import {ReferralDetails} from 'domain/usecases/private/my-referrals-flow/get-referrals-details';
import {makeGetReferrals} from 'main/factories/usecases/private/my-referrals-flow/get-referrals';
import {makeGetReferralDetails} from 'main/factories/usecases/private/my-referrals-flow/get-referral-details';

export const getReferrals = async (params: GetReferralsParams): Promise<GetReferralsModel> => {
	const result = await makeGetReferrals().get(params);
	const validStatuses = new Set<string>(Object.values(ReferralStatusEnum));
	const referrals = Array.isArray(result?.encaminhamentos)
		? result.encaminhamentos.filter(
				referral =>
					typeof referral?.status === 'string' && validStatuses.has(referral.status),
			)
		: [];

	return {
		...result,
		encaminhamentos: referrals,
	};
};

export const getReferralDetails = async (
	cdSenha: string,
	signal?: AbortSignal,
): Promise<ReferralDetails> => {
	const result = await makeGetReferralDetails().get({cdSenha, signal});
	return result;
};
